import { inject } from '@angular/core';
import {
  HttpResponse,
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { throwError } from 'rxjs';
import { finalize, tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from './loader.component';
import { LocalStorageItemsService } from '../services/local-storage-items.service';
import { ApiUrls } from './apiurls';

// Functional interceptor for modern Angular
export const apiCallInterceptor: HttpInterceptorFn = (req, next) => {
  const loader = inject(LoaderService);
  const router = inject(Router);
  const toastr = inject(ToastrService);

  // console.log('API Request URL:', req.url);

  const skipLoaderApis = [ApiUrls.check_record_exists];
  const skipErrorToastApis = [ApiUrls.getting_auth_url];

  const shouldSkipLoader = skipLoaderApis.some((api) => req.url.includes(api));
  // const shouldSkipErrorToast = skipErrorToastApis.some((api) => req.url.includes(api));

  // Show loader only if NOT skipped
  if (!shouldSkipLoader) loader.showLoader('loader1');

  // Clone request with necessary headers
  const modifiedReq = req.clone({
    url: req.url.replace(/%/, '%25').replace('#', '%23'),
    setHeaders: {
      'cache-control': 'no-cache',
    },
    withCredentials: true,
  });

  return next(modifiedReq).pipe(
    tap((event) => {
      if (event instanceof HttpResponse) {
        const res: any = event.body;
        if (res?.message?.success === false) {
          const errorMsg =
            (res.message.error ?? res?.message?.message)?.toString()?.trim();
          if (errorMsg) {
            toastr.error(errorMsg);
          }
        }
      }
    }),
    finalize(() => {
      // Hide loader when request completes
      loader.hideLoader();
    }),
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 || err.error?.exc_type === 'CSRFTokenError') {
        toastr.error(err?.error?.message);
        // localStorage.clear();
        LocalStorageItemsService.clearAll();
        router.navigate(['']);
      } else if (err.status === 500) {
        toastr.error('Internal Error 500');
      } else if (err.status === 403) {
        toastr.error('Insufficient Permission');
        const exception = err.error?.exception ?? '';
        const shouldClearStorage =
          exception.includes('Login to') ||
          exception.includes('is not whitelisted') ||
          err.error?.exc_type === 'PermissionError';
        if (shouldClearStorage) {
          localStorage.clear();
          window.location.reload();
          // localStorage.setItem('logout-event', Date.now().toString());
        }
      } else if (err.status === 409) {
        toastr.error('Already Exists');
      } else if (err.status === 400) {
        toastr.error('Bad Request');
      } else if (err.status === 417 || err.status === 404) {
        try {
          const msg = JSON.parse(
            JSON.parse(err?.error?._server_messages)
          )?.message;
          toastr.error(msg);
        } catch {
          toastr.error('Error occurred');
        }
      }
      return throwError(() => err);
    })
  );
};
